import { useCalendarView } from "./useCalendarView";
import styles from "./styles.module.scss";
import primaryComponents from "../../../../primaryComponents";
import { AngleLeft, AngleRight } from "../../../../../assets/svgIcons";
import { useEffect } from "react";

const DAYS = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

export const CalendarView = ({
  availability = [],
  bookDetails = {},
  setQueryParams = () => {},
  setBookDetails = () => {},
}) => {
  const {
    monthLabel,
    calendarDays,
    month,
    year,
    goToPrevMonth,
    goToNextMonth,
  } = useCalendarView({ availability });

  useEffect(() => {
    setQueryParams((prev) => ({ ...prev, month: month + 1, year: year }));
  }, [month, year]);

  return (
    <section className={styles.calendarView}>
      <div className="d-flex justify-content-between align-items-center">
        <primaryComponents.Button
          classNames={"btn btn--outline"}
          onClick={() => goToPrevMonth()}
        >
          <AngleLeft />
        </primaryComponents.Button>

        <h4 className="mx-auto mb-0">{monthLabel}</h4>

        <primaryComponents.Button
          classNames={"btn btn--outline"}
          onClick={() => goToNextMonth()}
        >
          <AngleRight />
        </primaryComponents.Button>
      </div>

      <div className={styles.weekdays} style={{ gap: "10px" }}>
        {DAYS?.map((day) => (
          <span
            key={day}
            className={`${styles.day} smallest-text-size font-weight-bold`}
          >
            {day}
          </span>
        ))}
      </div>

      <div className={styles.dateView}>
        {calendarDays.map((item, index) => {
          const booking_date = item?.date;
          const isActiveDate =
            booking_date === bookDetails?.active_booking_date;

          return item?.type === "empty" ? (
            <div key={index} />
          ) : (
            <div
              key={item?.date}
              className={`${styles.date} ${!item?.availability ? styles.noData : !item?.availability?.is_available ? styles.notAvailable : ""} ${isActiveDate ? styles.active : ""}`}
              onClick={() => {
                if (item?.availability?.is_available)
                  setBookDetails((prev) => ({
                    ...prev,
                    active_booking_date: booking_date,
                  }));
              }}
            >
              <h4
                className={`${isActiveDate ? "white--text" : !item?.availability?.is_available ? "gray--text" : ""}`}
              >
                {item?.day}
              </h4>

              {item?.availability ? (
                item?.availability?.is_available ? (
                  <span
                    className={`smallest-text-size ${styles.availableStatus} px-1`}
                  >
                    ({item?.availability?.available_slots})
                  </span>
                ) : (
                  <span
                    className={`smallest-text-size ${styles.notAvailableStatus}`}
                  >
                    Unavailable
                  </span>
                )
              ) : null}
            </div>
          );
        })}
      </div>
    </section>
  );
};
